import * as React from 'react';
import { Tag } from '../Types/Tag';
import { formatMarkdown, htmlIf } from '../Utils/HTML';
import { PackageCustomQuestionResponse } from '../Types/Package';

export const RequestDescription = (
  description: string,
  tags: Tag[],
  packageCustomQuestionResponses?: PackageCustomQuestionResponse[]
) => (
  <div className="">
    <h3>Overview</h3>
    <div>{formatMarkdown(description)}</div>
    {htmlIf(tags?.length > 0,
      <>
        {tags?.map((tag) =>
          <div key={`tag-${tag.id}`} className="badge bg-accent badge-sm text-dark me-1 d-inline-block mt-1">{tag.name}</div>
        )}
      </>
    )}
    {htmlIf(packageCustomQuestionResponses.length > 0,
      <div className="mt-3">
        <div className="mb-2 fw-semibold fs-lg text-dark">Additional Details</div>
        {packageCustomQuestionResponses.map((question) => (
          <div className="fs-md mb-2" key={question.id}>
            <div className="">{question.question}</div>
            <div className="">{question.answer}</div>
          </div>
        ))}
      </div>
    )}
  </div>
)

export default RequestDescription;
